import type { BrickType, PowerUpId, TimedPowerId } from './types';

export const FIELD = { w: 960, h: 640 } as const;
export const HUD_H = 52;
export const WALL = 10;
export const START_LIVES = 3;
export const BALL_R = 8;
export const PADDLE_H = 14;
export const PADDLE_Y = FIELD.h - 36;
export const PADDLE_SPEED = 620;
export const COLS = 14;
export const BRICK_GAP = 4;
export const BRICK_H = 22;
export const GRID_TOP = 72;
export const GRID_PAD_X = 36;

export const BRICK_POINTS: Record<Exclude<BrickType, 'i'>, number> = {
  n: 10,
  s: 20,
  t: 30,
  e: 30,
  b: 25,
  h: 20,
  v: 20,
};

export const BRICK_HP: Record<BrickType, number> = {
  n: 1,
  s: 2,
  t: 3,
  i: Infinity,
  e: 1,
  b: 1,
  h: 2,
  v: 2,
};

export const DROP_RATE = { normal: 0.06, bonus: 0.28, maxFalling: 2 };
export const COMBO_STEP = 0.25;
export const COMBO_CAP = 4;
export const LEVEL_BONUS = 500;
export const LIFE_BONUS = 200;
export const EXTRA_LIFE_AT = [10_000, 25_000, 50_000, 100_000];
export const HIGH_SCORE_KEY = 'brick-breaker-high-score';
export const MUTE_KEY = 'brick-breaker-mute';
export const UNLOCKED_KEY = 'brick-breaker-unlocked';
export const MAX_BALLS = 5;
export const MAX_TIMED = 3;
export const PICKUP_SCORE = 50;
export const BLAST_COUNT = 6;
export const LASER_COOLDOWN = 280;
export const SHIELD_Y = FIELD.h - 8;
export const MIN_VY_RATIO = 0.22;
export const MAX_PADDLE_ANGLE = Math.PI / 3;
export const RALLY_STEP = 0.035;
export const RALLY_CAP = 0.28;
export const PICKUP_FALL = 140;

export const POWER_DURATION: Record<TimedPowerId, number> = {
  bigPaddle: 10_000,
  smallPaddle: 10_000,
  slowBall: 8_000,
  fastBall: 8_000,
  fireBall: 8_000,
  magnet: 12_000,
  laser: 10_000,
  piercing: 7_000,
};

export const POWER_LABEL: Record<PowerUpId, string> = {
  bigPaddle: 'Wide Paddle',
  smallPaddle: 'Tiny Paddle',
  slowBall: 'Slow Ball',
  fastBall: 'Fast Ball',
  multiBall: 'Multi Ball',
  fireBall: 'Fire Ball',
  extraLife: 'Extra Life',
  shield: 'Shield',
  magnet: 'Magnet',
  laser: 'Laser',
  piercing: 'Pierce',
  brickBlast: 'Brick Blast',
};

export const POWER_COLOR: Record<PowerUpId, string> = {
  bigPaddle: '#13f4ff',
  smallPaddle: '#ff8a3d',
  slowBall: '#7dffb3',
  fastBall: '#ff5d7a',
  multiBall: '#ffe14d',
  fireBall: '#ff4d2e',
  extraLife: '#ff6bd6',
  shield: '#6ea8ff',
  magnet: '#c07bff',
  laser: '#ff3d6e',
  piercing: '#9dfff0',
  brickBlast: '#ffbf47',
};

export const BRICK_FILL: Record<BrickType, string> = {
  n: '#2ee6ff',
  s: '#7d5cff',
  t: '#ff36d1',
  i: '#4b5678',
  e: '#ff6b2d',
  b: '#ffe14d',
  h: '#3dff9a',
  v: '#3dff9a',
};

export const WIDTH_GROUP: TimedPowerId[] = ['bigPaddle', 'smallPaddle'];
export const SPEED_GROUP: TimedPowerId[] = ['slowBall', 'fastBall'];
export const PASS_GROUP: TimedPowerId[] = ['fireBall', 'piercing'];
export const TIMED_IDS: TimedPowerId[] = [
  'bigPaddle',
  'smallPaddle',
  'slowBall',
  'fastBall',
  'fireBall',
  'magnet',
  'laser',
  'piercing',
];
